export default "__VITE_ASSET__btxtRjFt__"